// extracted by mini-css-extract-plugin
export default {"root":"gift_card_details_root__GkcZ+","full_width":"gift_card_details_full_width__eDmit","menu":"gift_card_details_menu__Z0wcb"};